var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenceTypeDoorOpening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.99967L12.6666 2.66634M13.9999 1.33301L12.6666 2.66634L13.9999 1.33301ZM7.59327 7.73967C7.9375 8.07932 8.21114 8.4837 8.39844 8.92954C8.58574 9.37537 8.683 9.85385 8.68462 10.3374C8.68624 10.821 8.59219 11.3001 8.40788 11.7472C8.22357 12.1943 7.95265 12.6005 7.6107 12.9424C7.26876 13.2844 6.86255 13.5553 6.41547 13.7396C5.96839 13.9239 5.48927 14.018 5.00569 14.0164C4.52212 14.0147 4.04363 13.9175 3.5978 13.7302C3.15196 13.5429 2.74758 13.2692 2.40794 12.925C1.74003 12.2335 1.37045 11.3073 1.3788 10.3459C1.38715 9.38448 1.77277 8.46484 2.4526 7.78501C3.13243 7.10518 4.05208 6.71956 5.01347 6.7112C5.97486 6.70285 6.90106 7.07243 7.59261 7.74034L7.59327 7.73967ZM7.59327 7.73967L10.3333 4.99967L7.59327 7.73967ZM10.3333 4.99967L12.3333 6.99967L14.6666 4.66634L12.6666 2.66634L10.3333 4.99967Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceTypeDoorOpening);
export default __webpack_public_path__ + "static/media/licence_type_door_opening.c9d84697d62feb7b1145657d715cd6fe.svg";
export { ForwardRef as ReactComponent };